export default ['$sce', ($sce) => (text) => $sce.trustAsHtml(text)];